/* eslint-disable react-hooks/exhaustive-deps */
import { Button } from "primereact/button";
import { useEffect, useReducer } from "react";
import FieldTextBox from "../../shared/controls/fieldTextBox";
import formReducer from "../../shared/forms/formReducer";
import useApiTalleresExternos from "../../api/catalogos/useApiTalleresExternos";
import FormHandler from "../../shared/forms/formHandler";
import TalleresExternosValidacionEsquema from "./TalleresExternosValidacionEsquema";
import ReadOnlyProvider from "../../shared/forms/ReadOnlyProvider";

const TalleresExternosDetalle = ({ marcaLlantaId, onSave, soloLectura }) => {
    const api = useApiTalleresExternos();
    const defaultEntity = () => ({ entity: { id: 0, esMarcaInterna: false } });

    const [{ entity, errors }, dispatch] = useReducer(
        formReducer, {}, defaultEntity
    );

    const formHandler = new FormHandler({
        validationSchema: TalleresExternosValidacionEsquema,
        api,
        dispatch
    });

    useEffect(() => {
        async function cargar() {
            const marcaLlanta = await api.obtener(marcaLlantaId);

            dispatch({ type: "update", value: marcaLlanta });
        }

        if (marcaLlantaId > 0) {
            cargar().then();
        }
    }, []);

    const guardar = async () => {
        await formHandler.save(entity);

        if (formHandler.valdation.result) {
            onSave();
        }
    };

    const actualizar = (value, propertyName) => {
        dispatch({
            type: 'update',
            value: value,
            name: propertyName
        });
    };

    return (
        <>
            <div className="form-container full-height">
                <h5>Talleres Externos</h5>
                <ReadOnlyProvider defaultReadOnly={soloLectura}>
                    <div className="form-row">
                        <FieldTextBox name="nombre" label="Nombre" colMd={12} required value={entity.nombre}
                            onChange={actualizar} errors={errors} />
                    </div>
                    
                </ReadOnlyProvider>
                <div className="form-footer">
                    {!soloLectura &&
                        <Button label="Guardar" type="button" onClick={guardar} />
                    }
                </div>
            </div>
        </>
    );
};

export default TalleresExternosDetalle;